import { createSelector } from 'reselect';
import { getMaterialPickingEnabled } from './getMaterialPickingEnabled';

/**
 * `allowRejects` for every embedded labor-ticket-form context
 * (mm-integrations #487). Material-picking machines enter good parts only.
 */
const getLaborFormAllowRejects = createSelector(
  [getMaterialPickingEnabled],
  (materialPickingEnabled) => {
    return !materialPickingEnabled;
  }
);

export { getLaborFormAllowRejects };
